import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import dashboardHintsEn from './locales/dashboardHints/en.json';
import dashboardHintsEs from './locales/dashboardHints/es.json';
import dashboardHintsPt from './locales/dashboardHints/pt-BR.json';
import en from './locales/en.json';
import es from './locales/es.json';
import ptBR from './locales/pt-BR.json';

function mergeDashboardHints(localeBundle, hints) {
  return {
    ...localeBundle,
    dashboard: {
      ...localeBundle.dashboard,
      hints
    }
  };
}

const resources = {
  en: { translation: mergeDashboardHints(en, dashboardHintsEn) },
  es: { translation: mergeDashboardHints(es, dashboardHintsEs) },
  'pt-BR': { translation: mergeDashboardHints(ptBR, dashboardHintsPt) },
  pt: { translation: mergeDashboardHints(ptBR, dashboardHintsPt) }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    supportedLngs: ['en', 'es', 'pt-BR', 'pt'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      // Only restore a previous choice from app data; otherwise use Portuguese
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
